import React from 'react';

import BrandPromoBanners from '../BrandPromoBanners/BrandPromoBanners';
import BrandSectionList from '../BrandSectionList/BrandSectionList';
import BrandNovelties from '../BrandNovelties/BrandNovelties';
import BrandCategorySections from '../BrandCategorySections/BrandCategorySections';
import ProductSlider from '../ProductSlider/ProductSlider';
import Product from '../Product/Product';
import Lang from '../Lang/Lang';
import {langSiteDir} from '../../common/baseData';

function BrandPage(props) {
  const {
    banners,
    sections,
    novelties = {},
    categoryBlocks,
    messages,
    viewedProducts = {},
    youtubeArticles = [],
  } = props;

  const { items: noveltiesItems, title: noveltiesTitle, buttonTitle: noveltiesButtonTitle } = novelties;

  return (
    <>
      <div className='max-w-[1600px] px-[20px] mx-auto'>
        {Array.isArray(banners) && banners.length > 0 && (
          <BrandPromoBanners items={banners}/>
        )}

        {Array.isArray(sections) && sections.length > 0 && (
          <BrandSectionList items={sections}/>
        )}

        {Array.isArray(noveltiesItems) && noveltiesItems.length > 0 &&  (
          <BrandNovelties
            items={noveltiesItems}
            title={noveltiesTitle}
            buttonTitle={noveltiesButtonTitle}
          />
        )}
      </div>

      {Array.isArray(categoryBlocks) && categoryBlocks.length > 0 && (
        <BrandCategorySections
          items={categoryBlocks}
          messages={messages}
        />
      )}

      {Object.prototype.hasOwnProperty.call(viewedProducts, 'items') &&
        Array.isArray(viewedProducts.items) &&
        viewedProducts.items.length > 0 && (
          <div className="max-w-[1600px] desktop:px-[20px] mx-auto">
            <ProductSlider {...viewedProducts} key="viewed-product-list">
              {viewedProducts.items.map((item, index) => (
                <Product
                  {...item}
                  key={`viewed-${index}`}
                  itemKey={`viewed-${index}`}
                  gaParams={viewedProducts.gaParams}
                  last={index === viewedProducts.items.length - 1}
                />
              ))}
            </ProductSlider>
          </div>
        )}

      {Array.isArray(youtubeArticles) && youtubeArticles.length > 0 && (
        <div className="max-w-[1600px] desktop:px-[20px] mx-auto">
          <section className="my-10 flex flex-col">
            <div className="px-5 pb-3 flex justify-between items-baseline desktop:justify-normal desktop:gap-3 desktop:px-0">
              <span className="text-[16px] leading-[24px] font-medium text-grey-90 desktop:text-[24px] desktop:leading-[36px]">
                {Lang.getMessage('Youtube news')}
              </span>
              <a
                href={`${langSiteDir}news/rubric_youtube/`}
                className="inline-block w-auto text-blue-primary text-[14px] leading-[21px] underline desktop:text-[16px] desktop:leading-[24px] hover:no-underline"
              >
                {Lang.getMessage('All youtube videos')}
              </a>
            </div>

            <ul className="px-5 flex gap-3 overflow-x-scroll scroll-smooth snap-x snap-mandatory overscroll-x-none invisible-scrollbar desktop:px-0 desktop:gap-5">
              {youtubeArticles.map((article, index) => (
                <li
                  key={`article-${index}`}
                  className="flex flex-col w-[200px] desktop:w-[295px] shrink-0">
                  <a href={article.link} className="content-play">
                    <picture>
                      {article.picture?.webp && (
                        <source srcSet={article.picture.webp} type="image/webp"/>
                      )}
                      {article.picture?.avif && (
                        <source srcSet={article.picture.avif} type="image/avif"/>
                      )}
                      <img
                        src={article.picture?.src || ''}
                        className="max-w-[100%] max-h-[100%] object-cover desktop:h-[193px]"
                        width="295px"
                        height="125px"
                        loading="lazy"
                        alt=""
                      />
                    </picture>
                  </a>
                  <a
                    href={article.link}
                    className="line-clamp-2 mt-2 text-[14px] leading-[21px] text-grey-90 font-medium desktop:mt-3 desktop:text-[16px] desktop:leading-[24px]">
                    {article.title}
                  </a>
                  <p className="line-clamp-2 mt-3 text-[12px] leading-[18px] text-grey-90 font-medium desktop:text-[14px] desktop:leading-[21px]">
                    {article.preview}
                  </p>
                  <span className="mt-3 text-[11px] leading-[16px] text-grey-40 font-medium desktop:text-[14px] desktop:leading-[21px] desktop:text-grey-80">
                    {article.date}
                  </span>
                </li>
              ))}
            </ul>
          </section>
        </div>
      )}
    </>
  );
}

export default BrandPage;